export default import.meta.ROLLDOWN_FILE_URL_2ClJQInomgWWHzlG3IFhuA